import React from "react"
import { Grid } from "@material-ui/core"
import { Plus } from "lucide-react"
import { ContactItem } from "./components/ContactItem/ContactItem"
import { useContacts } from "./hooks/useContacts"
import { ContactSkeleton } from "./components/ContactSkeleton"
import useStyles from "./ContactListStyles"
import textoTruncar from "../../utils/textoTruncar"
import { getChaveContatoLista, getTipoContato, isMesmoContato } from "../../helpers/tipoContato"

const ContactList = ({
  canalFilter = 0,
  multiplos = false,
  searchParam = "",
  setContactModalOpen,
  mContatosSelecionados,
  setMContatosSelecionados,
  scrollContainerRef = null,
}) => {
  const classes = useStyles()
  const { contacts, isLoadingMore, listRef } = useContacts({ searchParam, scrollContainerRef, canalFilter })

  const handleChange = (contato) => {
    setMContatosSelecionados((prev) => {
      const cTipoContato = getTipoContato(contato)
      const lContatoJaSelecionado = prev.some((c) => isMesmoContato(c, contato))

      if (multiplos) {
        if (lContatoJaSelecionado) {
          return prev.filter((c) => !isMesmoContato(c, contato))
        }
        return [...prev, { ...contato, tipo: cTipoContato }]
      }
      return [{ ...contato, tipo: cTipoContato }]
    })
  }

  return (
    <div
      ref={scrollContainerRef ? null : listRef}
      className={classes.container}
      style={scrollContainerRef ? { overflow: "visible", height: "auto" } : {}}
    >
      <Grid container style={{ float: "right" }}>
        {contacts.map((contato) => {
          const isSelected = mContatosSelecionados.some((c) => isMesmoContato(c, contato))

          return (
            <ContactItem
              key={getChaveContatoLista(contato)}
              contato={contato}
              isSelected={isSelected}
              onSelect={handleChange}
              multiplos={multiplos}
            />
          )
        })}

        {isLoadingMore &&
          Array.from({ length: 3 }).map((_, i) => <ContactSkeleton key={`more-${i}`} multiplos={multiplos} />)}

        {!isLoadingMore && (
          <div className={classes.emptyContainer}>
            {contacts.length === 0 && <span className={classes.emptyText}>Nenhum resultado encontrado</span>}

            {setContactModalOpen && (
              <div className={classes.registerOption} onClick={() => setContactModalOpen(true)}>
                <span>Cadastrar {searchParam ? textoTruncar(searchParam, 20) : "contato"}</span>
                <Plus size={24} />
              </div>
            )}
          </div>
        )}
      </Grid>
    </div>
  )
}

export default ContactList
